'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ElementPortal = require('./ElementPortal');

var _ElementPortal2 = _interopRequireDefault(_ElementPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

var withElementPortal = function withElementPortal(Child) {
  var Portal = function Portal(_ref) {
    var id = _ref.id,
        selector = _ref.selector,
        shouldReset = _ref.shouldReset,
        mapDomNodeToProps = _ref.mapDomNodeToProps,
        childProps = _objectWithoutProperties(_ref, ['id', 'selector', 'shouldReset', 'mapDomNodeToProps']);

    var ChildWrapper = function ChildWrapper(props) {
      return _react2.default.createElement(Child, _extends({}, childProps, props));
    };
    return _react2.default.createElement(_ElementPortal2.default, {
      id: id,
      selector: selector,
      mapDomNodeToProps: mapDomNodeToProps,
      shouldReset: shouldReset,
      view: ChildWrapper
    });
  };

  Portal.displayName = 'WithElementPortal(' + getDisplayName(Child) + ')';

  return Portal;
};

exports.default = withElementPortal;